import React, { useEffect, useRef, useState } from 'react'
import Menu from '../icons/Menu'
import { supabase } from '../../services/supabaseClient'

const PlatFormMenu = ({ color }) => {
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef(null)

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  // Close the dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const logoutUser = async () => {
    await supabase.auth.signOut()
  }

  return (
    <div className="relative" ref={menuRef}>
      {/* Hamburger Icon */}
      <div
        className="flex flex-col justify-between w-6 h-6 cursor-pointer"
        onClick={toggleDropdown}
      >
        <Menu color={color} />
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute z-50 top-8 left-0 md:right-0 md:left-auto bg-white shadow-lg rounded-md p-2 w-40">
          <div
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
            onClick={logoutUser}
          >
            Log out
          </div>
        </div>
      )}
    </div>
  )
}

export default PlatFormMenu
